import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import Markdown from "markdown-to-jsx";
import { useLang } from "@/common/Contexts/LanguageContext";
import SellTradeTermsAr from "../../../data/sell-trade-terms/ar.json";
import SellTradeTermsEn from "../../../data/sell-trade-terms/en.json";
var SellTradeTermsPage = function SellTradeTermsPage() {
  var lang = useLang();
  var terms = lang === "ar" ? SellTradeTermsAr : SellTradeTermsEn;
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    linksForSearch: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "container py-10"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "font-bold text-xl leading-8 text-primary-new mb-6"
  }, terms.title), /*#__PURE__*/React.createElement("div", {
    className: "text-[#00143C] leading-6 [&>strong]:text-sm [&>strong]:leading-[25px] [&>strong]:text-primary-new [&>strong]:block [&>strong]:mb-2.5 [&_ol+strong]:mt-10 [&>p]:text-sm [&>p]:text-primary-new [&_p>strong]:text-primary-new [&_p>strong]:text-sm [&_ol]:list-decimal [&_ol]:p-0 [&_ol]:ps-4 [&_ol>li]:text-sm [&_ol>li]:mb-2.5 [&_ol>li]:leading-[22px]"
  }, /*#__PURE__*/React.createElement(Markdown, null, terms.description))));
};
export default SellTradeTermsPage;